import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { useTranslation } from "react-i18next";

const PersonDetailAdditional = () => {
  const {t} = useTranslation()
  return (
    <>
      <Row>
        <Col sm={12}>
          <NFTextInput title={t("Email")} fieldName={"email"} />
        </Col>
      </Row>
    </>
  );
};

export default PersonDetailAdditional;
